import React from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui';
import { useCurrentUser } from '../contexts/UserContext';

export function Header() {
  const { signOut } = useAuth();
  const { user } = useUser();
  const { user: currentUser } = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    console.log('Header: currentUser =', currentUser);
  }, [currentUser]);

  const handleSignOut = async () => {
    await signOut();
    navigate('/sign-in');
  };

  const navItems = [
    { label: 'How It Works', path: '/how-it-works', active: location.pathname === '/how-it-works' },
    { label: 'Campaigns', path: '/campaigns', active: location.pathname === '/campaigns' },
    ...(currentUser?.role === 'admin' ? [
      { label: 'Admin', path: '/admin', active: location.pathname === '/admin' }
    ] : []),
  ];

  return (
    <>
      <style>{`
        @media (max-width: 640px) {
          .header-user-email {
            display: none;
          }
        }
      `}</style>
      <header
        style={{
          borderBottom: '1px solid var(--color-border)',
          backgroundColor: 'var(--color-surface-1)',
          padding: 'var(--space-4)',
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}
      >
        <div
          className="header-row"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 'var(--space-4)',
            minWidth: 0,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-6)', minWidth: 0 }}>
            <div
              style={{ cursor: 'pointer', flexShrink: 0 }}
              onClick={() => navigate('/campaigns')}
            >
              <h1 style={{ margin: 0, fontSize: 'var(--text-lg)', fontWeight: 700, whiteSpace: 'nowrap' }}>
                Learn by Campaign
              </h1>
            </div>

            <nav style={{ display: 'flex', gap: 'var(--space-4)', flexShrink: 0 }}>
              {navItems.map(item => (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: item.active ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                    fontWeight: item.active ? 600 : 500,
                    borderBottom: item.active ? '2px solid var(--color-primary)' : 'none',
                    paddingBottom: 'var(--space-1)',
                    transition: 'color 0.2s ease',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    font: 'inherit',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-4)', flexShrink: 0 }}>
            <div
              className="header-user-email"
              style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', whiteSpace: 'nowrap' }}
            >
              {user?.primaryEmailAddress?.emailAddress}
            </div>
            <Button
              variant="secondary"
              size="sm"
              onClick={handleSignOut}
              style={{ flexShrink: 0 }}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </header>
    </>
  );
}
